<script setup lang="ts">
import { ref } from "vue";

const isModalOpen = ref(false);

const toggleModal = () => {
    isModalOpen.value = !isModalOpen.value;
};
</script>

<template>
    <div class="inline-block relative">
        <!-- 트리거 -->
        <div @click="toggleModal">
            <slot name="trigger" :onClick="toggleModal" />
        </div>

        <!-- 모달 -->
        <div v-if="isModalOpen" class="absolute left-0 top-full mt-2 z-100">
            <slot name="modal" :close="() => (isModalOpen = false)" />
        </div>
    </div>
</template>
